import React from "react";
import { Typography, Box } from "@mui/material";
import {MAIN_COLOR_BLUE} from "../utils/styles";

const Header = ({title,subtitle}:any) => {
    return (
        <Box style={{padding: 16}}>
            <Typography
                variant="body1"
                color={MAIN_COLOR_BLUE}
                fontWeight="bold"
                sx={{ mb: "5px" }}
            >
                {title}
            </Typography>
            <Typography variant="body2" color={MAIN_COLOR_BLUE}>
                {subtitle}
            </Typography>
        </Box>
    );
};

export default Header;
